module.exports = __webpack_public_path__ + "static/media/la police_crop-alt.acc9ebaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/la police_crop-alt.jpg
// module id = 416
// module chunks = 0